import React from "react";
import PageHeader from "../components/PageHeader";

export default function Sop() {
  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "SOP", link: "/sop" },
    { label: "Documents / Guidelines", active: true },
  ];

  const sops = [
    {
      title:
        "Standard Operating Procedures (SOP) for care and protection of children in Street Situation (2020)",
      file: "4.72 MB",
      link: "/assests/img/bscpcrRuleandActs/SOP_for_care_and_protection_of_children_in_Street_Situation_2020.pdf",
    },
    {
      title:
        "Standard Operating Procedures (SOP) for Implementation of Section 12(1)(c) of the RTE Act, 2009 – Model Procedures for Effective Implementation",
      file: "277.64 KB",
      link: "/assests/img/bscpcrRuleandActs/SOP_12_1_c_RTE_ACT_2009.pdf",
    },
  ];

  return (
    <>
      {/* Page Header */}
      <PageHeader
        title="SOP Documents / Guidelines"
        breadcrumbs={breadcrumbs}
      />

      {/* SOP Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center text-primary fw-bold mb-4">
            SOP Documents / Guidelines (Govt. of India)
          </h2>

          <div className="row g-4">
            {sops.map((sop, index) => (
              <div key={index} className="col-lg-6 col-md-6">
                <div className="h-100 bg-white p-4 rounded-4 shadow-sm border-start border-4 border-primary">
                  <h6 className="fw-bold text-primary mb-3">
                    {sop.title}
                  </h6>

                  <div className="d-flex justify-content-between text-muted small mb-3">
                  
                    <span>📄 {sop.file}</span>
                  </div>

                  <a
                    href={sop.link}
                    target="_blank"
                    className="btn btn-sm btn-primary rounded-pill w-100"
                  >
                    View / Download
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
